import { useEffect, useState } from "react";

export const useIsDesktop = (breakpoint = 768) => {
	const [isDesktop, setIsDesktop] = useState(false);

	useEffect(() => {
		const mediaQuery = window.matchMedia(`(min-width: ${breakpoint}px)`);
		setIsDesktop(mediaQuery.matches);

		const handleChange = (e: MediaQueryListEvent) => {
			setIsDesktop(e.matches);
		};

		mediaQuery.addEventListener("change", handleChange);
		return () => mediaQuery.removeEventListener("change", handleChange);
	}, [breakpoint]);

	return isDesktop;
};
